import ProxyBase from '../../../../../core/proxies/ProxyBase'

class FinanceProxy extends ProxyBase {
  postOrganizationInfo(params) {
    return this.post('OrganizationInfo', params)
  }

  postTotalCompany(params) {
    return this.post('TotalCompany', params)
  }

  postHightLight(params) {
    return this.post('Hightlight', params)
  }

  postLiquiditySolvencyAndCoverage(params) {
    return this.post('LiquiditySolvencyAndCoverage', params)
  }

  postAssetManagementEfficiency(params) {
    return this.post('AssetManagementEfficiency', params)
  }

  postProfitability(params) {
    return this.post('Profitability', params)
  }

  postBusinessGrowth(params) {
    return this.post('BusinessGrowth', params)
  }

  postCapitalAdequacy(params) {
    return this.post('CapitalAdequacy', params)
  }

  postAssetQuality(params) {
    return this.post('AssetQuality', params)
  }

  postEarningsQuality(params) {
    return this.post('EarningsQuality', params)
  }

  postFundingLiquidity(params) {
    return this.post('FundingLiquidity', params)
  }

  postBusinessPosition(params) {
    return this.post('BusinessPosition', params)
  }

  postCapitalEarningLeverage(params) {
    return this.post('CapitalEarningLeverage', params)
  }

  exportLiquiditySolvencyAndCoverage(params) {
    return this.post(
      'LiquiditySolvencyAndCoverage/export',
      params,
      undefined,
      'download',
    )
  }

  exportAssetManagementEfficiency(params) {
    return this.post(
      'AssetManagementEfficiency/export',
      params,
      undefined,
      'download',
    )
  }

  exportProfitability(params) {
    return this.post('Profitability/export', params, undefined, 'download')
  }

  exportBusinessGrowth(params) {
    return this.post('BusinessGrowth/export', params, undefined, 'download')
  }

  exportCapitalAdequacy(params) {
    return this.post('CapitalAdequacy/export', params, undefined, 'download')
  }

  exportAssetQuality(params) {
    return this.post('AssetQuality/export', params, undefined, 'download')
  }

  exportEarningsQuality(params) {
    return this.post('EarningsQuality/export', params, undefined, 'download')
  }

  exportFundingLiquidity(params) {
    return this.post('FundingLiquidity/export', params, undefined, 'download')
  }

  exportSecuritiesBusinessPosition(params) {
    return this.post(
      'Securities/BusinessPosition/export',
      params,
      undefined,
      'download',
    )
  }

  exportCapitalEarningLeverage(params) {
    return this.post(
      'CapitalEarningLeverage/export',
      params,
      undefined,
      'download',
    )
  }
}

export default new FinanceProxy('PortfolioInsights/Finance/')
